// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useTenantStore } from "@/providers/TenantContextProvider";
import { FETCH_ELECTION_EVENTS_TREE } from "@/queries/GetElectionEventsTree";
import { useQuery } from "@apollo/client";
import { useContext } from "react";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
import { SettingsContext } from "@/providers/SettingsContextProvider";
export function useTreeMenuData(isArchivedElectionEvents) {
    var tenantId = useTenantStore()[0];
    var globalSettings = useContext(SettingsContext).globalSettings;
    return useQuery(FETCH_ELECTION_EVENTS_TREE, {
        variables: {
            tenantId: tenantId,
            isArchived: isArchivedElectionEvents,
        },
        pollInterval: globalSettings.QUERY_POLL_INTERVAL_MS,
    });
}
export function useActionPermissions() {
    var tenantId = useTenantStore()[0];
    var authContext = useContext(AuthContext);
    /**
     * election event
     */
    var canCreateElectionEvent = authContext.isAuthorized(true, tenantId, IPermissions.ELECTION_EVENT_CREATE);
    var canWriteElectionEvent = authContext.isAuthorized(true, tenantId, IPermissions.ELECTION_EVENT_WRITE);
    var canDeleteElectionEvent = authContext.isAuthorized(true, tenantId, IPermissions.ELECTION_EVENT_DELETE);
    var canReadElectionEvent = authContext.isAuthorized(true, tenantId, IPermissions.ELECTION_EVENT_READ);
    var canArchiveElectionEvent = authContext.isAuthorized(true, tenantId, IPermissions.ELECTION_EVENT_ARCHIVE);
    /**
     * election
     */
    var canWriteElection = authContext.isAuthorized(true, tenantId, IPermissions.ELECTION_WRITE);
    var canReadElection = authContext.isAuthorized(true, tenantId, IPermissions.ELECTION_READ);
    var canCreateElection = authContext.isAuthorized(true, tenantId, IPermissions.ELECTION_CREATE);
    var canDeleteElection = authContext.isAuthorized(true, tenantId, IPermissions.ELECTION_DELETE);
    /**
     * contest
     */
    var canWriteContest = authContext.isAuthorized(true, tenantId, IPermissions.CONTEST_WRITE);
    var canReadContest = authContext.isAuthorized(true, tenantId, IPermissions.CONTEST_READ);
    var canCreateContest = authContext.isAuthorized(true, tenantId, IPermissions.CONTEST_CREATE);
    var canDeleteContest = authContext.isAuthorized(true, tenantId, IPermissions.CONTEST_DELETE);
    /**
     * candidate
     */
    var canWriteCandidate = authContext.isAuthorized(true, tenantId, IPermissions.CANDIDATE_WRITE);
    var canReadCandidate = authContext.isAuthorized(true, tenantId, IPermissions.CANDIDATE_READ);
    var canCreateCandidate = authContext.isAuthorized(true, tenantId, IPermissions.CANDIDATE_CREATE);
    var canDeleteCandidate = authContext.isAuthorized(true, tenantId, IPermissions.CANDIDATE_DELETE);
    return {
        canCreateElectionEvent: canCreateElectionEvent,
        canReadElectionEvent: canReadElectionEvent,
        canDeleteElectionEvent: canDeleteElectionEvent,
        canWriteElectionEvent: canWriteElectionEvent,
        canArchiveElectionEvent: canArchiveElectionEvent,
        canWriteElection: canWriteElection,
        canReadElection: canReadElection,
        canCreateElection: canCreateElection,
        canDeleteElection: canDeleteElection,
        canWriteContest: canWriteContest,
        canReadContest: canReadContest,
        canCreateContest: canCreateContest,
        canDeleteContest: canDeleteContest,
        canWriteCandidate: canWriteCandidate,
        canReadCandidate: canReadCandidate,
        canCreateCandidate: canCreateCandidate,
        canDeleteCandidate: canDeleteCandidate,
    };
}
